import { all } from 'redux-saga/effects'
import { Sagas as AppSaga } from 'modules/App/store/saga'
import AuthSaga from 'modules/Auth/store/saga'
import NotificationsSaga from 'modules/Notifications/store/saga'

export const staticSagas = [AuthSaga, AppSaga, NotificationsSaga]

export function* rootStaticSaga() {
  yield all(staticSagas.map((saga) => saga()))
}
